import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { ReportCategoriesResponse } from "./types/reports/responses/ReportCategoriesResponse";
import { GenerateReportsResponse } from "./types/reports/responses/GenerateReportsResponse";
import { GenerateReportsRequest } from "./types/reports/requests/GenerateReportsRequest";
import { ReportsIndexResponse } from "./types/reports/responses/ReportsIndexResponse";

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["Reports"],
  endpoints: (builder) => ({
    getReportCategories: builder.query<ReportCategoriesResponse, void>({
      query: () => ({
        url: "/residents/reports/categories",
        method: "GET",
      }),
    }),
    generateReports: builder.mutation<
      GenerateReportsResponse,
      GenerateReportsRequest
    >({
      query: (body) => ({
        url: "/residents/reports/generate",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Reports"],
    }),
    getReportsIndex: builder.query<ReportsIndexResponse, void>({
      query: () => ({
        url: "/residents/reports",
        method: "GET",
      }),
      providesTags: ["Reports"],
    }),
  }),
});

export const {
  useGetReportCategoriesQuery,
  useGenerateReportsMutation,
  useGetReportsIndexQuery,
} = reportsApi;
